import { render } from "./LocationsPage.vue?vue&type=template&id=acbfddbc"
import script from "./LocationsPage.vue?vue&type=script&lang=js"
export * from "./LocationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__